import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import app from "./app";
import companies from "./companies";
import company from "./company";
import event from "./event";
import chat from "../../chat/reducers/chat";
import profile from "./profile";
import broadcast from "./broadcast";
import jobs from "./jobs";
import applies from "./applies";
import login from "./login";
import registration from "./registration";
import questions from "./questions";

import { reducer as formReducer } from "redux-form";

export default history =>
  combineReducers({
    router: connectRouter(history),
    form: formReducer,
    app,
    broadcast,
    companies,
    event,
    company,
    chat,
    jobs,
    applies,
    profile,
    login,
    registration,
    questions,
  });
